import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, Tabs, Tab, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import Compliance from './Compliance';
import QualityMetrics from './QualityMetrics';

// Styled Components - Consistent with other pages
const HeaderCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  marginBottom: theme.spacing(3),
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(102, 126, 234, 0.2)',
}));

export default function BIReporting() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabs = [
    { label: 'Compliance', component: <Compliance /> },
    { label: 'Quality Metrics', component: <QualityMetrics /> },
  ];

  return (
    <Box sx={{ p: 4, background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh' }}>
      <HeaderCard>
        <CardContent sx={{ py: 2, px: 3, '&:last-child': { pb: 2 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <AnalyticsIcon sx={{ fontSize: 32, color: 'white' }} />
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', mb: 0.5 }}>
                BI Reporting
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                Compliance monitoring and quality metrics
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </HeaderCard>

      <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#f8f9fa' }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': {
                minHeight: 64,
                fontSize: '1rem',
                fontWeight: 500,
                textTransform: 'none',
                color: '#6c757d',
                '&.Mui-selected': {
                  color: '#708bff',
                  fontWeight: 600,
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#708bff',
                height: 3,
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
              />
            ))}
          </Tabs>
        </Box>
        
        <Box sx={{ p: 3 }}>
          {tabs[activeTab].component}
        </Box>
      </Paper>
    </Box>
  );
}
